   
const weekDays = [
    {diaSemana: "D",
        id: 0},
    {diaSemana: "S",
        id: 1},
    {diaSemana: "T",
        id: 2},
    {diaSemana: "Q",
        id: 3}, 
    {diaSemana: "Q",
        id: 4}, 
    {diaSemana: "S",
        id: 5}, 
    {diaSemana: "S",
        id: 6}]

        export default weekDays;